import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAgendaSearchNoResultsWrapper} from '@/features/agenda/components/agenda-sidebar-search/style'

export const AgendaSidebarSearchLoader = () => {
    return Array.from({length: 3}).map((_, index) => (
        <StyledAgendaSearchNoResultsWrapper key={index}>
            <Skeleton width={`calc(100% - ${index * 40}px)`} height="24px" />
        </StyledAgendaSearchNoResultsWrapper>
    ))
}
